/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".account-list[_ngcontent-%COMP%], .invoice-table[_ngcontent-%COMP%]{margin-left:auto;margin-right:auto;max-width:1024px;margin-bottom:1rem}"];
export { styles as styles };
